import { polyfill } from 'seamless-scroll-polyfill';
polyfill();
import 'web-animations-js';
import 'zone.js';
